import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import { ApiService } from "../../service/ApiService";

export const getBlogArticle = createAsyncThunk(
  "blogArticle/getBlogArticle",
  async (tag, { rejectWithValue }) => {
    try {
      if (!tag) return;

      const { data } = await ApiService.getBlogArticle(tag);

      return data;
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const saveServerBlogArticle = createAction(
  "blogArticle/saveServerBlogArticle",
);
